import { DishComponent } from '../apiTypes';

export const concatComponents = (componentsA: DishComponent[], componentsB: DishComponent[]) =>
  [...componentsA, ...componentsB].reduce<DishComponent[]>((accumulator, current) => {
    const index = accumulator.findIndex((item) => item.id === current.id && item.store === current.store);

    if (index !== -1) {
      // eslint-disable-next-line no-param-reassign
      accumulator[index] = { ...accumulator[index]!, qnt: (accumulator[index]?.qnt || 0) + current.qnt };
    } else {
      accumulator.push(current);
    }

    return accumulator;
  }, []);
